import React, { JSX } from 'react';

import { IInventoryRule } from '~/src/dash/apiV2/inventory-rules/inventoryRules';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { formatCommaSeparated } from '~/src/dash/utils/string';
import { ColKeyValuePair } from '~/src/dash/views/inventory-rules-v2/Rules/InventoryRulesList/InventoryRuleDrawer/ColKeyValuePair';

interface IProps {
  rule: IInventoryRule;
}

export const InventoryRuleContent = ({ rule }: IProps): JSX.Element => {
  const {
    ContentCategory,
    ContentChannel,
    ContentContext,
    ContentDistributionID,
    ContentDistributionName,
    ContentEpisode,
    ContentGenre,
    ContentID,
    ContentKeywords,
    ContentLanguage,
    ContentLength,
    ContentNetwork,
    ContentProdQuality,
    ContentProducerID,
    ContentProducer,
    ContentRating,
    ContentSeason,
    ContentSeries,
    ContentTaxonomy,
    ContentTitle,
    ContentURL,
  } = rule;
  return (
    <Rows gap={spacing.small}>
      <Row noPadding>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='circle-play' small />
          </Col>
          <Col>
            <Text small bold tKey='Content' singleLineLabel />
          </Col>
        </Cols>
      </Row>
      <Row largeHorizontalPadding noVerticalPadding>
        <Cols
          wrap
          gap={spacing.medium}
          style={{
            alignItems: 'flex-start',
          }}
        >
          {/* Content fields - only render if value exists */}
          {ContentCategory && (
            <ColKeyValuePair tKey='ContentCategory' value={formatCommaSeparated(ContentCategory)} />
          )}
          {ContentChannel && (
            <ColKeyValuePair tKey='ContentChannel' value={formatCommaSeparated(ContentChannel)} />
          )}
          {ContentContext && (
            <ColKeyValuePair tKey='ContentContext' value={formatCommaSeparated(ContentContext)} />
          )}
          {ContentDistributionID && (
            <ColKeyValuePair
              tKey='ContentDistributionID'
              value={formatCommaSeparated(ContentDistributionID)}
            />
          )}
          {ContentDistributionName && (
            <ColKeyValuePair
              tKey='ContentDistributionName'
              value={formatCommaSeparated(ContentDistributionName)}
            />
          )}
          {ContentEpisode && (
            <ColKeyValuePair tKey='ContentEpisode' value={formatCommaSeparated(ContentEpisode)} />
          )}
          {ContentGenre && (
            <ColKeyValuePair tKey='ContentGenre' value={formatCommaSeparated(ContentGenre)} />
          )}
          {ContentID && (
            <ColKeyValuePair tKey='ContentID' value={formatCommaSeparated(ContentID)} />
          )}
          {ContentKeywords && (
            <ColKeyValuePair tKey='ContentKeywords' value={formatCommaSeparated(ContentKeywords)} />
          )}
          {ContentLanguage && (
            <ColKeyValuePair tKey='ContentLanguage' value={formatCommaSeparated(ContentLanguage)} />
          )}
          {ContentLength !== undefined && ContentLength !== null && (
            <ColKeyValuePair tKey='ContentLength' value={String(ContentLength)} />
          )}
          {ContentNetwork && (
            <ColKeyValuePair tKey='ContentNetwork' value={formatCommaSeparated(ContentNetwork)} />
          )}
          {ContentProdQuality && (
            <ColKeyValuePair
              tKey='ContentProdQuality'
              value={formatCommaSeparated(ContentProdQuality)}
            />
          )}
          {ContentProducerID && (
            <ColKeyValuePair
              tKey='ContentProducerID'
              value={formatCommaSeparated(ContentProducerID)}
            />
          )}
          {ContentProducer && (
            <ColKeyValuePair tKey='ContentProducer' value={formatCommaSeparated(ContentProducer)} />
          )}
          {ContentRating && (
            <ColKeyValuePair tKey='ContentRating' value={formatCommaSeparated(ContentRating)} />
          )}
          {ContentSeason && (
            <ColKeyValuePair tKey='ContentSeason' value={formatCommaSeparated(ContentSeason)} />
          )}
          {ContentSeries && (
            <ColKeyValuePair tKey='ContentSeries' value={formatCommaSeparated(ContentSeries)} />
          )}
          {ContentTaxonomy && (
            <ColKeyValuePair tKey='ContentTaxonomy' value={formatCommaSeparated(ContentTaxonomy)} />
          )}
          {ContentTitle && (
            <ColKeyValuePair tKey='ContentTitle' value={formatCommaSeparated(ContentTitle)} />
          )}
          {ContentURL && (
            <ColKeyValuePair tKey='ContentURL' value={formatCommaSeparated(ContentURL)} />
          )}
        </Cols>
      </Row>
    </Rows>
  );
};
